<template>
  <div>
        <a-alert class="mt20" :message="tips" type="success" />
        <div class="mt20">
            <label for="">目标环境：</label>
            <a-radio-group v-model="targetEnv" @change="getAppSumData">
                <a-radio v-for="item in envNames" :key="item.key" :value="item.key">{{item.key}}</a-radio>
            </a-radio-group>

            <label for="" class="ml20">筛选：</label>
            <a-radio-group v-model="filtername" @change="getAppSumData">
                <a-radio value="nullonlly">仅目标不存在</a-radio>
                <a-radio value="diffonly">仅字段不同</a-radio>
                <a-radio value="all">所有</a-radio>

            </a-radio-group>

            <a-button class="fr" v-if="filtername != 'all' && tableData.length > 0" type="primary" @click="coverAll">覆盖所有</a-button>

        </div>
        <a-table :columns="columns" :data-source="tableData"  style="margin-top:20px;" :scroll="{ x: clientWidth}" 
            :pagination="false" :loading="tloading" rowKey="a_id" @change="handleTableChange">
            
            <template slot="compareResult" slot-scope="text, record">
                <span :class="record.span_color">{{text}}</span>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a-button type="link" @click="handleView(record)">查看</a-button>
                <a-button v-if="record.is_column_different" type="link" @click="handleCover(record)">覆盖</a-button>
            </template>
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    <a-modal title="字段对比" :visible="showDiff" width="900px"  @cancel="handleCancelF" >
         <a-table :columns="colums_diff" :data-source="data_diff" :pagination="false"  rowKey="title">
            <template slot="colorColum" slot-scope="text, record">
                <a-tag v-if="record.span_color" color="red">{{ text }}</a-tag>
                <span v-else>{{text}}</span>

            </template>
        </a-table>

        <template slot="footer">
            <a-button key="back" @click="handleCancelF">
            取消
            </a-button>
            <a-button key="submit" type="primary" :loading="tloading" @click="handleOk">
            覆盖
            </a-button>
        </template>
    </a-modal>

    <coverAll ref="coverAllID" @handleOver="handlePageChange(1)"></coverAll>
     
  </div>
</template>
<script>
import coverAll from "./coverAll.vue"
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

export default {
    data() {
        return {
            columns:[],
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:1200,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            envList:[
                'pre',
                'uat',
                'pet',
                'fat',
                'sit',
                'sim',
                'dev',
            ],
            targetEnv:'',
            filtername:'nullonlly',
            column_names:{
                executor_param:'servicekey/URL',
                job_desc:'任务标题',
                author:'负责人',
                authortel:'负责人电话',
                alarm_email:'钉钉机器人TOKEN',
                app_code:'应用编码',
                job_remark:'备注',
                version:'版本',
                schedule_type:'调度类型',
                schedule_conf:'Corn表达式/配置',
                glue_type:'运行模式',
                executor_handler:'JobHandler',
                executor_route_strategy:'路由策略',
                misfire_strategy:'调度过期策略',
                child_jobid:'子任务ID',
                executor_block_strategy:'阻塞处理策略',
                executor_timeout:'任务超时时间',
                executor_fail_retry_count:'executorFailRetryCount',
                job_param:'动态参数'
            },
                
            showDiff:false,
            temp_record:{},
            colums_diff:[],
            data_diff:[],
            tips:'提示：以当前环境数据覆盖目标环境数据'
        };
    },
    computed:{
        envNames(){
            let c_env = this.C.Env;
            let temp_env_list = this.envList.filter(item => { return item != c_env });
            let result = []
            temp_env_list.forEach(item => {
                let t_i = {
                    name:c_env + '->' + item,
                    key:item
                }
                result.push(t_i)
            });
            return result
        }
    },
    methods: {
        //覆盖所有，递归
        coverAll(){
            let that = this;
            let params = {
                ...that.searchP,
                appenv:that.C.Env,
                appenv_b:that.targetEnv,
                filtername:that.filtername,
                urlparams:false
            };
            this.$refs.coverAllID.init(params)
        },
        handleOk(){
            if(this.temp_record.a_executor_param){
                this.handleCover(this.temp_record)
            }
            else{
                this.message.warn('未选择')
            }
        },
        //覆盖
        handleCover(record){
            //appenv
            //id
            console.log(record);
            let params = {
                urlparams:false,
            }
            for(var key in this.column_names) {
                params[key] = record['a_'+key]
            }
            console.log(params);
            params.appenv_b = this.targetEnv

            //区分是添加还是更新
            if(record.b_id){
                //更新
                params.id = record.b_id
            }
        
            let that = this;
            that.tloading = true;

            that.$store.dispatch({
                type: "timetask/coverone",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.showDiff = false;
                    this.getAppSumData();
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });

        },
        //查看字段不同
        handleView(data){
            this.temp_record = data;
            let that = this;
            let titleA = this.C.Env;
            let titleB = that.targetEnv;
            that.data_diff = [];
            for(var key in this.column_names) {
                that.data_diff.push({
                    title:this.column_names[key],
                    data_a:data['a_'+key],
                    data_b:data['b_'+key],
                    span_color:data.different_columns.indexOf(key) != -1
                })
            }
            this.colums_diff = [
                {
                    title:'字段名',
                    dataIndex:'title',
                    width:120,
                    align:'center'
                },
                {
                    title:titleA,
                    dataIndex:'data_a',
                    scopedSlots: { customRender: 'colorColum' },
                    width:300,
                    align:'center'
                },
                {
                    title:titleB,
                    dataIndex:'data_b',
                    scopedSlots: { customRender: 'colorColum' },
                    width:300,
                    align:'center'
                },
            ]
            this.showDiff = true;
        },
        handleCancelF(){
            this.showDiff = false;
        },
        handleSearch(searchP){
            let tempSearchP = JSON.stringify(searchP)
            tempSearchP = JSON.parse(tempSearchP)
            if(!this.targetEnv){
                this.targetEnv = this.envNames[0].key
            }
            this.searchP = tempSearchP;
            this.searchP.triggerStatus = tempSearchP.triggerStatus == '-1' ? '' : tempSearchP.triggerStatus
            this.pagination.page = 1
            this.getAppSumData();
        },
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            that.tloading = true;
            let params = {
                ...that.searchP,
                appenv:that.C.Env,
                appenv_b:that.targetEnv,
                filtername:that.filtername,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "timetask/querydifpage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.handleResult(result.list);
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        //对比各字段
        compareItemColumn(data){
            let dif_list = []
            for(var key in this.column_names) {
                if(data['a_' + key] != data['b_' + key]){
                    //发现字段不同
                    dif_list.push(key)
                }
            }
            data.different_columns = dif_list;
            return dif_list.length > 0;
        },
        handleResult(res_list){
            let that = this;
            let titleA = this.C.Env;
            let titleB = that.targetEnv;
            res_list.forEach(element => {
                //字段不同
                //目标不存在
                //相同
                if(!element.b_executor_param){
                    element.compareResult = '目标不存在'
                    element.span_color = 'span_red'
                    element.is_column_different = true;
                    element.different_columns = []
                }
                else if(that.compareItemColumn(element)){
                    element.compareResult = '字段不同'
                    element.span_color = "span_yellow"
                    element.is_column_different = true;

                }else{
                    element.compareResult = '相同'
                    element.is_column_different = false;
                    element.span_color = "span_green"

                }
            });
            let columns = [
                {
                    title: "序号",
                    width: 50,
                    align: "center",
                    customRender: (text, record, index) => {
                        let { page, pageSize } = pagination;
                        return (Number(page) - 1) * Number(pageSize) + index + 1;
                    }
                },
                {
                    title:titleA,
                    dataIndex:'a_executor_param',
                    width:300,
                    align:'center'
                },
                {
                    title:titleB,
                    dataIndex:'b_executor_param',
                    width:300,
                    align:'center'
                },
                {
                    title:'对比结果',
                    dataIndex:'compareResult',
                    scopedSlots: { customRender: 'compareResult' },

                    width:120,
                    align:'center'
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    align: 'center',
                    width: 80,
                    scopedSlots: { customRender: 'operation' },
                },
    
            ];
            that.columns = columns;
            that.tableData =  res_list
        }
    },
    components:{
        coverAll
    },
    mounted(){
    }
};
</script>
<style scoped>
    .span_red{
        color: #ff4d4f;
    }
    .span_yellow{
        color: #faad14;
    }
    .span_green{
        color: #52c41a;
    }

    .bk_yellow{
        background-color: #ff4d4f;
    }
</style>
